import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
const ErrorPage = () => {
    const error = useRouteError();
    const message = isRouteErrorResponse(error)
        ? `${error.status} — ${error.statusText}`
        : error instanceof Error
            ? error.message
            : 'An unexpected error occurred.';
    return (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", gap: 2, children: [_jsx(Typography, { variant: "h4", fontWeight: 600, children: "Oops" }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: message }), _jsx(Button, { component: Link, to: "/", variant: "contained", children: "Go home" })] }));
};
export default ErrorPage;
